import React, { useEffect, useState, useCallback, useMemo } from "react";
import "./Header.css";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import logo from "../../../Assets/Images/Logo.png";
import { Button, Dropdown } from "react-bootstrap";
import LoginModal from "../../../Auth/LoginModal/LoginModal";
import SignupModal from "../../../Auth/SignupModal/SignupModal";
import { Link as ScrollLink, animateScroll as scroll } from "react-scroll"; // Rename Link from react-scroll to ScrollLink
import {
  Link as RouterLink,
  useNavigate,
  useLocation,
  useSearchParams,
} from "react-router-dom"; // Importing Link from react-router-dom
import { GetUserDetails } from "../../../Helpers/Utility";
import Avatar from "react-avatar";
import { getData } from "../../../Services/Api";
import SubscribeModal from "../../../Auth/SubscribeModal/SubscribeModal";
import { toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import axios from "axios";

export default function Header() {
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showSignUpModal, setShowSignUpModal] = useState(false);
  const [showSubscribe, setShowSubscribe] = useState(false);
  const [userRole, setUserRole] = useState(3);

  const navigate = useNavigate();
  const location = useLocation();

  const handleLoginModalClose = () => setShowLoginModal(false);
  const handleLoginModalShow = () => setShowLoginModal(true);

  const handleSubscribeModalClose = () => setShowSubscribe(false);

  const handleSubscribeModalShow = () => {
    if (subcribeData?.subscribedPlan != null) {
      setShowSubscribe(true);
    } else {
      setShowSubscribe(false);
      toast.info("You did not purchase any subscription plan");
    }
  };

  const handleSignUpModalClose = () => setShowSignUpModal(false);

  const handleSignUpModalShow = () => {
    // Close the login modal before opening the signup modal
    setShowLoginModal(false);
    setShowSignUpModal(true);
  };

  const handleSignInModalShow = () => {
    // Close the login modal before opening the signup modal
    setShowLoginModal(true);
    setShowSignUpModal(false);
  };

  const userDetails = useMemo(() => GetUserDetails(), []);

  const [subcribeData, setSubscribeData] = useState();

  const getUser = useCallback(async () => {
    if (userDetails) {
      const headers = {
        Authorization: `Bearer ${userDetails.token}`,
      };

      const response = await getData("subscription-status", headers);
      if (response.success === true) {
        setSubscribeData(response.data);
        sessionStorage.setItem(
          "subScriptionData",
          JSON.stringify(response?.data)
        );
      }
    }
  }, [userDetails]);

  const handleNavigation = (section) => {
    navigate("/", { state: { scrollToSection: section } });
  };

  useEffect(() => {
    getUser();
    if (location.state?.scrollToSection) {
      scroll.scrollTo(
        document.getElementById(location.state.scrollToSection).offsetTop - 0,
        { duration: 100, smooth: true }
      );
    }
    const loginDetails = JSON.parse(localStorage.getItem("loginDetails"));
    if (loginDetails) {
      setUserRole(loginDetails?.roleId);
    }
  }, [getUser, location.state]);

  const logout = () => {
    confirmAlert({
      title: "Confirm Logout",
      message: "Are you sure you want to logout?",
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            localStorage.removeItem("loginDetails");
            sessionStorage.removeItem("subScriptionData");
            window.location.reload(true);
            toast.success("Logged out successfully!");
            // try {
            //   const baseURL = process.env.REACT_APP_API_URL;
            //   const headers = {
            //     Authorization: `Bearer ${userDetails.token}`,
            //   };

            //   const response = await axios.post(`${baseURL}/logout`, {}, {
            //     headers,
            //   });
            //   if(response){
            //     localStorage.removeItem("loginDetails");
            //     sessionStorage.removeItem('subScriptionData');
            //     window.location.reload(true);
            //     toast.success("Logged out successfully!");
            //   }
            // } catch (error) {
            //   toast.error("An error occurred during logout: " + error.message);
            // }
          },
        },
        {
          label: "No",
          // onClick: () => console.log("Logout cancelled"),
        },
      ],
    });
  };

  const deleteaccount = () => {
    confirmAlert({
      title: "Confirm Delete Account",
      message: `Are you sure you want to delete your 123MyVPN account?

      Please note:

      - Your subscription package will no longer be accessible.
      - Your account and all associated data will be permanently deleted.
      - Refunds for subscription fees will not be provided.
      
      `,
      buttons: [
        {
          label: "Yes",
          onClick: async () => {
            try {
              const headers = {
                Authorization: `Bearer ${userDetails.token}`,
              };

              const baseURL = process.env.REACT_APP_API_URL;
              const response = await axios.delete(`${baseURL}/delete-user`, {
                headers,
              });
              if (response.status === 200) {
                localStorage.removeItem("loginDetails");
                window.location.reload(true);
                toast.success(response.data.message);
              }
            } catch (error) {
              toast.error(
                "An error occurred during delete account: " + error.message
              );
            }
          },
        },
        {
          label: "No",
        },
      ],
    });
  };

  return (
    <>
      <Navbar collapseOnSelect expand="lg" className="bg-white py-0">
        <Container>
          <Navbar.Brand href="">
            <RouterLink to="/" className="cursor-pointer">
              <img src={logo} alt="log" className="img-fluid" />
            </RouterLink>
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls="responsive-navbar-nav"
            className="dnd"
          />
          <Navbar.Collapse id="responsive-navbar-nav" className="py-2">
            <Nav className="respoNav m-auto justify-content-center">
              <ScrollLink
                onClick={() => handleNavigation("features")}
                to="features"
                spy={true}
                smooth={true}
                offset={-70}
                duration={100}
                className="px-3 d-flex cursor-pointer align-items-center navLinkHeader text-decoration-none fw-medium text-black respoNav py-2"
              >
                Features
              </ScrollLink>
              <RouterLink
                to="howitworks"
                className="px-3 d-flex cursor-pointer align-items-center navLinkHeader text-decoration-none fw-medium text-black respoNav py-2"
              >
                How it works
              </RouterLink>
              <ScrollLink
                onClick={() => handleNavigation("Pricing")}
                to="Pricing"
                spy={true}
                smooth={true}
                offset={-70}
                duration={100}
                className="px-3 navLinkHeader cursor-pointer d-flex align-items-center text-decoration-none fw-medium text-black respoNav py-2"
              >
                Pricing
              </ScrollLink>
            </Nav>
            {userDetails ? (
              <Nav>
                <Dropdown align="end">
                  <Dropdown.Toggle
                    as={Nav.Link}
                    className="p-0 d-flex justify-content-center align-items-center py-2"
                  >
                    <Avatar
                      name={userDetails?.name}
                      size="40"
                      round={true}
                      maxInitials={2}
                      color="#16a350"
                    />
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <div className="px-3 py-2 border-bottom">
                      <div className="fw-bold">Account</div>
                      <div className="py-2 d-flex align-items-center">
                        <div className="avatar">
                          <Avatar
                            name={userDetails?.name}
                            size="50"
                            round={true}
                            maxInitials={2}
                            color="#16a350"
                          />
                        </div>
                        <div className="d-flex flex-column">
                          <div className="px-2">{userDetails?.name}</div>
                          <small className="px-2 text-success">
                            {userDetails.email}
                          </small>
                        </div>
                      </div>
                    </div>
                    {userRole == 3 ? (
                      <>
                        <Dropdown.Item className="py-2" href="">
                          Remaining Data -{" "}
                          {/* <b>{`${
                          subcribeData?.subscriptionStatusInfo?.data_remaining.toFixed(2) ||
                          "0"
                        } GB`}</b> */}
                          <b>{`${
                            subcribeData?.subscriptionStatusInfo?.data_remaining
                              ? subcribeData.subscriptionStatusInfo
                                  .data_remaining %
                                  1 ===
                                0
                                ? subcribeData.subscriptionStatusInfo
                                    .data_remaining
                                : subcribeData.subscriptionStatusInfo.data_remaining.toFixed(
                                    2
                                  )
                              : "0"
                          } GB`}</b>
                        </Dropdown.Item>
                        <Dropdown.Item
                          className="py-2"
                          href=""
                          onClick={handleSubscribeModalShow}
                        >
                          Subscription History
                        </Dropdown.Item>
                        <Dropdown.Item className="py-2">
                          Subscription -{" "}
                          {subcribeData?.subscribedPlan?.name
                            ? subcribeData?.subscribedPlan?.name
                            : "None"}
                        </Dropdown.Item>
                        <Dropdown.Item onClick={deleteaccount}>
                          Delete Account
                        </Dropdown.Item>
                      </>
                    ) : null}
                    {userDetails?.roleId == 1 && (
                      <Dropdown.Item className="py-2" href="/dashboard">
                        Dashboard
                      </Dropdown.Item>
                    )}
                    {userDetails?.roleId == 2 && (
                      <Dropdown.Item className="py-2" href="/dashboard/chat">
                        Chats
                      </Dropdown.Item>
                    )}
                    <Dropdown.Item onClick={logout}>Logout</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </Nav>
            ) : (
              <Nav>
                <Nav.Link
                  className="fw-bold text-black d-block m-auto"
                  href="#pricing"
                >
                  <Button
                    className="respoNavBtn btn btn-default startedBtn rounded-5 pt-2 pb-2 px-4"
                    onClick={handleLoginModalShow}
                  >
                    GET STARTED
                  </Button>
                </Nav.Link>
              </Nav>
            )}
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <LoginModal
        show={showLoginModal}
        handleClose={handleLoginModalClose}
        handleSignUp={handleSignUpModalShow}
        showLoginModal={() => setShowLoginModal(true)}
      />
      <SignupModal
        show={showSignUpModal}
        handleClose={handleSignUpModalClose}
        handleSignIn={handleSignInModalShow}
      />
      <SubscribeModal
        subcribeData={subcribeData}
        showSubscribe={showSubscribe}
        handleSubscribeModalShow={handleSubscribeModalShow}
        handleSubscribeModalClose={handleSubscribeModalClose}
      />
    </>
  );
}
